import React from 'react';
import { Modal } from 'antd';
import { BannerItem, ChangeItem } from '@nxsys/types/models/banner';
import dayjs from 'dayjs';
import {
  StyledModalContent,
  StyledLogDetails,
  StyledUpdatedDate,
  StyledChangesSection,
  StyledChangeItem,
} from './index.styled';

type AppActivityLogModalProps = {
  visible: boolean;
  banner: BannerItem | null;
  onClose: () => void;
};

const formatChangeElement = (
  change: ChangeItem,
  date: string,
): React.ReactElement => {
  const formattedDate = dayjs(date).format('DD/MM/YYYY');
  const oldValueStr = String(change.oldValue ?? '_');
  const newValueStr = String(change.newValue ?? '_');

  if (
    change.oldValue === null ||
    change.oldValue === undefined ||
    change.oldValue === ''
  ) {
    // New value added (no previous value)
    return (
      <>
        {change.label} updated to{' '}
        <span className="value-tag">{newValueStr}</span> since{' '}
        <span className="value-tag">{formattedDate}</span>
      </>
    );
  }

  // Value changed
  return (
    <>
      {change.label} was change from{' '}
      <span className="value-tag">{oldValueStr}</span> to{' '}
      <span className="value-tag">{newValueStr}</span> on{' '}
      <span className="value-tag">{formattedDate}</span>
    </>
  );
};

const AppActivityLogModal: React.FC<AppActivityLogModalProps> = ({
  visible,
  banner,
  onClose,
}) => {
  if (!banner) return null;

  const changes = banner.changes || [];
  const updatedDate = dayjs(banner.updatedAt).format('DD/MM/YYYY HH:mm A');
  const isActivityLog = banner.bannerType === 'ACTIVITY_LOG';

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      title="New Update"
      footer={null}
      width={1000}
    >
      <StyledModalContent>
        <StyledLogDetails>
          {banner.logDetails || banner.summary}
        </StyledLogDetails>
        <StyledUpdatedDate>{updatedDate}</StyledUpdatedDate>

        {isActivityLog && changes.length > 0 && (
          <StyledChangesSection>
            {changes.map((change, index) => (
              <StyledChangeItem key={index}>
                {index + 1}. {formatChangeElement(change, banner.updatedAt)}
              </StyledChangeItem>
            ))}
          </StyledChangesSection>
        )}
      </StyledModalContent>
    </Modal>
  );
};

export default AppActivityLogModal;
